"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAttributeFilterParentsHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var general_1 = require("../../../events/general");
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var parentFiltersValidation_1 = require("./validation/parentFiltersValidation");
var common_1 = require("../common");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
function setAttributeFilterParentsHandler(ctx, cmd) {
    var _a, filterLocalId, parentFilters, allFilters, affectedFilter, displayFormsMap, validationResult, message, changedFilter;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, filterLocalId = _a.filterLocalId, parentFilters = _a.parentFilters;
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilters)];
            case 1:
                allFilters = _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(filterLocalId))];
            case 2:
                affectedFilter = _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectAttributeFilterDisplayFormsMap)];
            case 3:
                displayFormsMap = _b.sent();
                if (!affectedFilter) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Filter with localId " + filterLocalId + " was not found.");
                }
                return [4 /*yield*/, effects_1.call(parentFiltersValidation_1.validateAttributeFilterParents, ctx, affectedFilter, tslib_1.__spread(parentFilters), allFilters, displayFormsMap)];
            case 4:
                validationResult = _b.sent();
                if (validationResult !== "VALID") {
                    message = validationResult === "EXTRANEOUS_PARENT"
                        ? "Some of the parents provided cannot be used because filters for those are not in the filters collection. " +
                            "Only existing filters can be used as parent filters."
                        : validationResult === "INVALID_METADATA"
                            ? "Some of the parents provided cannot be used because the 'metadata' for parent filter are missing."
                            : "Some of the parents provided cannot be used because the 'over' parameter is invalid for the target filter.";
                    throw general_1.invalidArgumentsProvided(ctx, cmd, message);
                }
                return [4 /*yield*/, effects_1.put(filterContext_1.filterContextActions.setAttributeFilterParents({
                        filterLocalId: filterLocalId,
                        parentFilters: parentFilters,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(filterLocalId))];
            case 6:
                changedFilter = _b.sent();
                ts_invariant_1.default(changedFilter, "Inconsistent state in attributeFilterSetParentCommandHandler");
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.attributeFilterParentChanged(ctx, changedFilter, cmd.correlationId))];
            case 7:
                _b.sent();
                return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 8:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.setAttributeFilterParentsHandler = setAttributeFilterParentsHandler;
//# sourceMappingURL=setAttributeFilterParentHandler.js.map